import * as React from 'react';

import {FormOpenLeadSlack} from '../../forms/slack/form-open-lead-slack';

import {SalesAutomationEditorSidebar} from './sidebar/sales-automation-editor-sidebar';

type OwnProps = {
    isNew: boolean;
    entityId: string | null | undefined;
    parentId: string;
};

type Props = OwnProps;

export class OpenLeadSlackEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        return (
            <SalesAutomationEditorSidebar
                onSave={this.handleSidebarFormSave}
                title={this.props.isNew ? 'Add Slack message' : 'Edit Slack message'}
            >
                <FormOpenLeadSlack
                    entityId={this.props.entityId}
                    parentId={this.props.parentId}
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                />
            </SalesAutomationEditorSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
